export type MapNode = {
  Utanrikisthjonusta: string
  IcelandicName: string
  CountryName: string
  CountryCode: string
  Continent: string
  type: string
  OECDtype: string
  UNstatus: string
  MoreType?: string
}

export const mapResolver = (customJson: any): MapNode[] => {
  const mapDataJson = JSON.parse(customJson.text)
  const { mapdata } = mapDataJson
  const dataArr: MapNode[] = Array.from(mapdata)
  return dataArr
}

export interface CountryNode extends MapNode {
  classNamePostfix: string
}

export const countryResolver = (
  customProps: MapNode[],
  geoProps: any
): CountryNode | undefined => {
  const { adm0_a3: code } = geoProps

  const result = customProps.find(n => n.CountryCode === code)

  if (result) {
    return {
      ...result,
      classNamePostfix: result.type
        .replace(/ /g, '-')
        .replace('&', 'og')
        .toLocaleLowerCase()
    }
  } else return result
}
